import React from "react";

import { RegularButton, ActionButton } from "colbi_web_ui/lib/components/inputs";

import styles from "./ConfirmDialog.module.sass";
const buildText = (text) => {
    if (Array.isArray(text)) {
        return (
            <ul>
                {text.map((val, index) => (
                    <li key={index}>
                        <small>{val}</small>
                    </li>
                ))}
            </ul>
        );
    }

    return text ? <small>{text}</small> : <></>;
};
const ConfirmDialog = (props) => {
    const { data, confirm, cancel, i18n } = props;
    const { title, text, promptText } = data;

    return (
        <div className={styles["root"]}>
            <div className={styles["content"]}>
                <h5 className={styles["title"]}>{title}</h5>
                {buildText(text)}
            </div>
            <div className={styles["actions"]}>
                <div className={styles["prompt"]}>
                    <small>{promptText}</small>
                </div>
                <RegularButton
                    className={styles["action-button"]}
                    type="button"
                    onClick={() => {
                        cancel && cancel();
                    }}
                >
                    <strong>{i18n`Cancel`}</strong>
                </RegularButton>
                <ActionButton
                    className={styles["action-button"]}
                    type="button"
                    onClick={() => {
                        confirm && confirm();
                    }}
                >
                    <strong>{i18n`Confirm`}</strong>
                </ActionButton>
            </div>
        </div>
    );
};

export default ConfirmDialog;
